export default "__VITE_ASSET__Cv9O53mJ__"